import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";

export function NavItem({
  to,
  icon,
  label,
  badge,
}: {
  to: string;
  icon: ReactNode;
  label: string;
  badge?: number;
}) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        [
          "relative flex items-center gap-2.5 px-2.5 py-2 rounded-md text-[13px]",
          "hover:bg-[rgba(233,242,238,0.08)]",
          isActive
            ? "font-semibold text-on-dark-bright bg-[rgba(233,242,238,0.1)] " +
              "before:content-[''] before:absolute before:left-0 before:top-1.5 before:bottom-1.5 before:w-0.5 before:bg-accent before:rounded-full"
            : "font-medium text-on-dark-muted",
        ].join(" ")
      }
    >
      <span className="w-[18px] inline-flex opacity-85">{icon}</span>
      <span className="flex-1 text-left">{label}</span>
      {badge !== undefined && badge > 0 && (
        <span className="text-[10.5px] font-semibold bg-danger text-white rounded-full px-2 py-[1px]">
          {badge}
        </span>
      )}
    </NavLink>
  );
}
